import $axios from "@/service/httpServer";
// export const baseUrl = "http://api.fat.nhdc.com";
export const baseUrl = "";

// const baseUrl = "http://yapi.newhope.cn/mock/452";
// export const baseUrl = "http://10.3.4.67:8913";

// 销售经理-数据展示-认购签约统计
export const dataShowStatistic = (p) =>
  $axios.post(
    `http://api2.newhope.cn/openapi/open/customer/recommend/App/dataShowStatistic`,
    p
  );

// 销售经理-数据展示-认购签约列表
export const dataShowList = (p) =>
  $axios.post(
    `http://api2.newhope.cn/openapi/open/customer/recommend/App/dataShowList`,
    p
  );

// 销售经理-数据展示-各个状态统计
export const allStatusStatistical = (p) =>
  $axios.post(
    `http://api2.newhope.cn/openapi/open/customer/recommend/App/allStatusStatistical`,
    p
  );

// 销售经理-客户跟进页面
// export const pmFollowList = (p) =>
//   $axios.get(`${baseUrl}/marketing/recommend/App/pmFollowList`, p);
export const pmFollowList = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/App/recommendList`, p);
// 销售经理-回收站列表
// export const recyclingList = (p) =>
//   $axios.get(`${baseUrl}/marketing/recommend/App/recyclingList`, p);
export const recyclingList = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/App/recommendList`, p);

// 销售经理-(回收站)-还原
export const revert = (p) =>
  $axios.post(`${baseUrl}/marketing/recommend/App/revert`, p);

// 根据userId获取用户职位判断是否可以自动进行客户分配
export const getPositionsByuserId = (p) =>
  $axios.get(`${baseUrl}/customer/consultant/getPermissionByOA`, p);
